import { render, staticRenderFns } from "./EmployersList.vue?vue&type=template&id=7a11944a&"
import script from "./EmployersList.vue?vue&type=script&lang=js&"
export * from "./EmployersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports